import { ContentBlockIds } from 'enums/ContentBlockIds';
import SkipLink from './components/SkipLink';
import styles from './SkipLinks.module.scss';

const SkipLinks = () => {
  return (
    <div aria-label="Skip links" role="region" className={styles.skipLinksContainer}>
      <SkipLink label="Skip to content" targetId={ContentBlockIds.MainContent} />
      <SkipLink label="Skip to footer" targetId={ContentBlockIds.FooterContent} />
    </div>
  );
};

export default SkipLinks;
